import { BorderColor, VerticalAlignBottom } from "@mui/icons-material";
import { BsThreeDotsVertical } from "@/Components/Icons/Icons";
import { Divider } from "@mui/material";

export default {
  row1: [
    {
      column: "column1",
      rows: {
        row1: [
          {
            name: "overseasAgent",
            checkboxLabel: "Overseas Agent",
            component: "checkboxBox",
          },
          {
            name: "localAgent",
            checkboxLabel: "Local Agent",
            component: "checkboxBox",
          },
        ],
        row2: [
          {
            name: "Commission",
            actionText: "Commission",
            component: "typographytext",
            placeholder: "100.00%",
            width: "20%",
            sx: {
              // height:"70PX",
              alignItems: "center",
            },
          },
          {
            name: "commission",
            component: "text-field",
            placeholder: "100.00%",
            width: "20%",
            gap: false,
            dataType: "int",

            //    sx:{
            //     height:"",
            //     alignItems: "end"
            // }
          },
          {
            name: "Incentive",
            actionText: "Incentive",
            component: "typographytext",
            placeholder: "100.00%",
            width: "12%",

            sx: {
              // height:"65PX",
              alignItems: "center",
            },
          },
          {
            name: "profitSharing",
            component: "text-field",
            placeholder: "100.00%",
            width: "20%",
            gap: false,
            dataType: "int",
          },
        ],
        row3: [
          {
            name: "pro",
            actionText: "Profit Sharing",
            component: "typographytext",
            placeholder: "100.00%",
            width: "20%",
            sx: {
              // height:"65PX",
              alignItems: "center",
            },
          },
          {
            name: "incentive",
            component: "text-field",
            placeholder: "100.00%",
            width: "20%",
            gap: false,
            dataType : "int"

          },
          {
            name: "Sales Person",
            component: "outlinebutton",
            sx: {
              borderColor: "var(--gray-300)",
              minWidth: "0",
            },
            width: "2%",
            iconName: BsThreeDotsVertical,
            iconSpacing: 0,
            iconPosition: "start",
            disabled : true
          },
        ],
      },
    },
  ],
};
